"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var REFRESH_LINEAR_PLAYBACK_HEARTBEAT = function () { return "mutation LinearPlaybackHeartbeat($channelId: ID!, $deviceId: ID!) {\n    linearPlaybackHeartbeat(channelId: $channelId, deviceId: $deviceId) {\n        timeToNextHeartbeat\n    }\n}"; };
exports.default = REFRESH_LINEAR_PLAYBACK_HEARTBEAT;
//# sourceMappingURL=refreshLinearPlaybackHeartbeat.js.map